import { get, qs } from '@/lib/api';

export interface Paged<T> {
  data: T[];
  nextCursor: string | null;
}

export async function getPages<T>(path: string, params: Record<string, string | number | boolean | undefined>, maxPages = 5): Promise<T[]> {
  const rows: T[] = [];
  let cursor: string | undefined;
  for (let page = 0; page < maxPages; page += 1) {
    const result = await get<Paged<T>>(`${path}${qs({ ...params, cursor })}`);
    rows.push(...result.data);
    if (!result.nextCursor) break;
    cursor = result.nextCursor;
  }
  return rows;
}
